import React, { useState, useEffect } from "react";
import { SEO } from "../components/SEO";
import { Zap, ChevronLeft, ChevronRight, MessageCircle, Eye, Play } from "lucide-react";
import { Link } from "react-router-dom";

// Mock data for blog posts
export const heroPosts = {
  main: {
    category: "Software ERP",
    categoryColor: "bg-purple-500",
    title: "O Guia Definitivo: Como um ERP revoluciona o chão de fábrica",
    author: "Equipe RosTech",
    date: "19 Abr, 2026",
    comments: 12,
    views: 345,
    image: "https://images.unsplash.com/photo-1621293954908-907159247fc8?auto=format&fit=crop&q=80&w=1200",
    icon: <Play className="w-8 h-8 text-white ml-1" />,
    slug: "guia-definitivo"
  },
  topRight: {
    category: "Gestão",
    categoryColor: "bg-emerald-500",
    title: "5 Dicas essenciais para organizar o estoque de autopeças e evitar perdas",
    author: "João Silva",
    date: "18 Abr, 2026",
    comments: 8,
    views: 210,
    image: "https://images.unsplash.com/photo-1530982011887-3cc11cc85693?auto=format&fit=crop&q=80&w=800",
    slug: "5-dicas-essenciais"
  },
  bottomRight1: {
    category: "Financeiro",
    categoryColor: "bg-purple-500",
    title: "Fluxo de caixa para oficinas: pare de perder dinheiro",
    author: "Maria Costa",
    date: "18 Abr, 2026",
    comments: 4,
    views: 156,
    image: "https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?auto=format&fit=crop&q=80&w=600",
    slug: "fluxo-de-caixa"
  },
  bottomRight2: {
    category: "Atendimento",
    categoryColor: "bg-emerald-500",
    title: "Como fidelizar o cliente após a primeira revisão",
    author: "admin",
    date: "17 Abr, 2026",
    comments: 15,
    views: 420,
    image: "https://images.unsplash.com/photo-1600880292203-757bb62b4baf?auto=format&fit=crop&q=80&w=600",
    slug: "fidelizando-cliente"
  }
};

export const recentPosts = [
  {
    id: 1,
    title: "Calculando o custo da hora domecânico",
    summary: "Aprenda a precificar corretamente os serviços da sua oficina para garantir lucro real no final do mês.",
    category: "Gestão",
    image: "https://images.unsplash.com/photo-1486262715619-679df11f6f33?auto=format&fit=crop&q=80&w=600",
    date: "15 Abr, 2026"
  },
  {
    id: 2,
    title: "Vantagens da emissão de NF-e integrada ao PDV",
    summary: "Diga adeus a retrabalhos e processos manuais. Entenda os benefícios da integração fiscal no seu sistema.",
    category: "Tecnologia",
    image: "https://images.unsplash.com/photo-1554224154-26032ffc0d04?auto=format&fit=crop&q=80&w=600",
    date: "12 Abr, 2026"
  },
  {
    id: 3,
    title: "Tecnologia automotiva: o futuro das oficinas",
    summary: "Carros híbridos e elétricos já são realidade. Sua oficina está preparada para consertar esses veículos?",
    category: "Inovação",
    image: "https://images.unsplash.com/photo-1560958089-b8a1929cea89?auto=format&fit=crop&q=80&w=600",
    date: "10 Abr, 2026"
  },
  {
    id: 4,
    title: "Checklist de veículo digital: aumento da confiança",
    summary: "Mostrar problemas com fotos e vídeos diretamente no WhatsApp do cliente aumenta a taxa de conversão.",
    category: "Vendas",
    image: "https://images.unsplash.com/photo-1518972458649-b082b1419409?auto=format&fit=crop&q=80&w=600",
    date: "08 Abr, 2026"
  },
  {
    id: 5,
    title: "Avaliando a produtividade da sua equipe",
    summary: "Saiba quais métricas acompanhar para entender se seus mecânicos estão desempenhando o máximo potencial.",
    category: "RH & Gestão",
    image: "https://images.unsplash.com/photo-1581092160562-40aa08e78837?auto=format&fit=crop&q=80&w=600",
    date: "05 Abr, 2026"
  },
  {
    id: 6,
    title: "Como reduzir inadimplência na oficina em 50%",
    summary: "Táticas de cobrança, opções de parcelamento e processos que diminuem significativamente os calotes.",
    category: "Financeiro",
    image: "https://images.unsplash.com/photo-1579621970588-a35d0e7ab2b6?auto=format&fit=crop&q=80&w=600",
    date: "02 Abr, 2026"
  }
];

export const Blog = () => {
  const [tickerIndex, setTickerIndex] = useState(0);

  const nextTicker = () => setTickerIndex((prev) => (prev + 1) % recentPosts.length);
  const prevTicker = () => setTickerIndex((prev) => (prev - 1 + recentPosts.length) % recentPosts.length);

  useEffect(() => {
    const interval = setInterval(nextTicker, 5000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="bg-white min-h-screen pb-20">
      <SEO 
        title="Blog - Gestão de Oficinas | RosTech" 
        description="Conteúdos completos sobre gestão de oficinas mecânicas, ERP, controle de peças e muito mais."
        canonicalUrl="/blog"
      />

      {/* Breaking News Ticker */}
      <div className="max-w-[1400px] mx-auto px-4 mt-8 mb-4">
        <div className="flex items-center border-b border-slate-200 pb-2">
          {/* Arrows */}
          <div className="flex items-center gap-1 mr-4 shrink-0">
            <button onClick={prevTicker} className="p-1.5 border border-slate-200 hover:bg-slate-50 transition-colors text-slate-400">
              <ChevronLeft className="w-5 h-5" />
            </button>
            <button onClick={nextTicker} className="p-1.5 border border-slate-200 hover:bg-slate-50 transition-colors text-slate-400">
              <ChevronRight className="w-5 h-5" />
            </button>
          </div>
          
          {/* Badge & Text */}
          <div className="flex items-center flex-1 overflow-hidden">
            <div className="bg-[#0f172a] text-white text-[13px] font-bold px-4 py-2 flex items-center shrink-0 uppercase tracking-wider gap-2 mr-4">
              <Zap className="w-4 h-4 text-white fill-white" />
              Notícias
            </div>
            <Link 
              to={`/blog/artigo-${recentPosts[tickerIndex].id}`} 
              className="text-[#024a8a] hover:text-blue-700 text-[15px] font-medium truncate flex-1 transition-colors"
            >
              {recentPosts[tickerIndex].title}
            </Link>
          </div>
        </div>
      </div>

      {/* Hero Grid Section */}
      <div className="max-w-[1400px] mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-1.5 h-auto lg:h-[600px]">
          
          {/* Main Left Post */}
          <Link to="/blog/guia-definitivo" className="relative group overflow-hidden h-[400px] lg:h-full cursor-pointer block">
            <img 
              src={heroPosts.main.image} 
              alt={heroPosts.main.title}
              className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/40 to-transparent"></div>
            
            {/* Play Button Overlay */}
            <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
              <div className="w-16 h-16 rounded-full border-2 border-white/40 flex flex-col items-center justify-center bg-transparent backdrop-blur-sm group-hover:border-white transition-colors duration-300">
                {heroPosts.main.icon}
              </div>
            </div>

            <div className="absolute bottom-0 left-0 p-8 w-full">
              <span className={`inline-block ${heroPosts.main.categoryColor} text-white text-xs font-bold px-3 py-1 rounded-sm mb-4`}>
                {heroPosts.main.category}
              </span>
              <h2 className="text-white text-3xl font-bold leading-tight mb-4 group-hover:text-blue-100 transition-colors">
                {heroPosts.main.title}
              </h2>
              <div className="flex items-center text-gray-300 text-xs font-medium space-x-4">
                <span>{heroPosts.main.author}</span>
                <span>{heroPosts.main.date}</span>
                <span className="flex items-center"><MessageCircle className="w-3 h-3 mr-1" /> {heroPosts.main.comments}</span>
                <span className="flex items-center"><Eye className="w-3 h-3 mr-1" /> {heroPosts.main.views}</span>
              </div>
            </div>
          </Link>

          {/* Right Column */}
          <div className="flex flex-col gap-1.5 h-full">
            {/* Top Right Post */}
            <Link to="/blog/5-dicas-essenciais" className="relative group overflow-hidden flex-1 cursor-pointer block">
              <img 
                src={heroPosts.topRight.image} 
                alt={heroPosts.topRight.title}
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/30 to-transparent"></div>
              <div className="absolute bottom-0 left-0 p-6 w-full">
                <span className={`inline-block ${heroPosts.topRight.categoryColor} text-white text-xs font-bold px-3 py-1 rounded-sm mb-3`}>
                  {heroPosts.topRight.category}
                </span>
                <h2 className="text-white text-2xl font-bold leading-tight mb-3 group-hover:text-blue-100 transition-colors">
                  {heroPosts.topRight.title}
                </h2>
                <div className="flex items-center text-gray-300 text-xs font-medium space-x-4">
                  <span>{heroPosts.topRight.author}</span>
                  <span>{heroPosts.topRight.date}</span>
                  <span className="flex items-center"><MessageCircle className="w-3 h-3 mr-1" /> {heroPosts.topRight.comments}</span>
                  <span className="flex items-center"><Eye className="w-3 h-3 mr-1" /> {heroPosts.topRight.views}</span>
                </div>
              </div>
            </Link>

            {/* Bottom Right Split */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-1.5 flex-1 min-h-[250px]">
              
              {/* Bottom Right 1 */}
              <Link to="/blog/fluxo-de-caixa" className="relative group overflow-hidden h-full cursor-pointer block">
                <img 
                  src={heroPosts.bottomRight1.image} 
                  alt={heroPosts.bottomRight1.title}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/40 to-transparent"></div>
                <div className="absolute bottom-0 left-0 p-5 w-full">
                  <span className={`inline-block ${heroPosts.bottomRight1.categoryColor} text-white text-[10px] font-bold px-2 py-0.5 rounded-sm mb-2`}>
                    {heroPosts.bottomRight1.category}
                  </span>
                  <h3 className="text-white text-lg font-bold leading-tight mb-2 group-hover:text-blue-100 transition-colors">
                    {heroPosts.bottomRight1.title}
                  </h3>
                  <div className="flex items-center text-gray-300 text-[10px] font-medium space-x-3">
                    <span>{heroPosts.bottomRight1.author}</span>
                    <span>{heroPosts.bottomRight1.date}</span>
                    <span className="hidden xl:flex items-center"><MessageCircle className="w-3 h-3 mr-1" /> {heroPosts.bottomRight1.comments}</span>
                    <span className="hidden xl:flex items-center"><Eye className="w-3 h-3 mr-1" /> {heroPosts.bottomRight1.views}</span>
                  </div>
                </div>
              </Link>

              {/* Bottom Right 2 */}
              <Link to="/blog/fidelizando-cliente" className="relative group overflow-hidden h-full cursor-pointer block">
                <img 
                  src={heroPosts.bottomRight2.image} 
                  alt={heroPosts.bottomRight2.title}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/40 to-transparent"></div>
                <div className="absolute bottom-0 left-0 p-5 w-full">
                  <span className={`inline-block ${heroPosts.bottomRight2.categoryColor} text-white text-[10px] font-bold px-2 py-0.5 rounded-sm mb-2`}>
                    {heroPosts.bottomRight2.category}
                  </span>
                  <h3 className="text-white text-lg font-bold leading-tight mb-2 group-hover:text-blue-100 transition-colors">
                    {heroPosts.bottomRight2.title}
                  </h3>
                  <div className="flex items-center text-gray-300 text-[10px] font-medium space-x-3">
                    <span>{heroPosts.bottomRight2.author}</span>
                    <span>{heroPosts.bottomRight2.date}</span>
                    <span className="hidden xl:flex items-center"><MessageCircle className="w-3 h-3 mr-1" /> {heroPosts.bottomRight2.comments}</span>
                    <span className="hidden xl:flex items-center"><Eye className="w-3 h-3 mr-1" /> {heroPosts.bottomRight2.views}</span>
                  </div>
                </div>
              </Link>

            </div>
          </div>
        </div>
      </div>

      {/* Editor's Choice / Recent Posts Section */}
      <section className="py-20">
        <div className="max-w-[1400px] mx-auto px-4">
          <div className="flex items-center mb-10 border-b border-slate-200 pb-4">
            <h2 className="text-2xl font-extrabold text-slate-900 border-b-2 border-slate-900 pb-4 -mb-[17px]">
              Mais Lidos da Semana
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {recentPosts.map((post) => (
              <Link to={`/blog/artigo-${post.id}`} key={post.id} className="group cursor-pointer flex flex-col h-full bg-white border border-slate-100 rounded-lg overflow-hidden shadow-sm hover:shadow-xl transition-shadow">
                <div className="relative h-56 overflow-hidden">
                  <img src={post.image} alt={post.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                  <div className="absolute top-4 left-4 bg-blue-600 text-white text-[10px] font-bold uppercase tracking-wider px-2.5 py-1 rounded">
                    {post.category}
                  </div>
                </div>
                <div className="p-6 flex flex-col flex-1">
                  <p className="text-xs text-slate-400 mb-3 font-medium">{post.date}</p>
                  <h3 className="text-xl font-bold text-slate-900 mb-3 group-hover:text-blue-600 transition-colors line-clamp-2">
                    {post.title}
                  </h3>
                  <p className="text-slate-600 text-sm leading-relaxed mb-6 line-clamp-3 flex-1">
                    {post.summary}
                  </p>
                  <span className="text-blue-600 font-bold text-sm tracking-wide uppercase group-hover:text-blue-800 transition-colors inline-flex items-center">
                    Ler artigo <ChevronRight className="w-4 h-4 ml-1" />
                  </span>
                </div>
              </Link>
            ))}
          </div>
          
          <div className="mt-16 text-center">
            <button className="bg-slate-900 hover:bg-slate-800 text-white font-bold py-4 px-10 rounded-lg transition-colors inline-flex items-center dark:bg-slate-100 dark:text-slate-900 dark:hover:bg-slate-200">
               Carregar mais publicações
            </button>
          </div>
        </div>
      </section>

      {/* Newsletter Subscription */}
      <section className="bg-blue-50 py-16 mt-8">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-3xl font-extrabold text-slate-900 mb-4">Inscreva-se na nossa Newsletter</h2>
          <p className="text-slate-600 mb-8 text-lg">
            Receba semanalmente as melhores dicas e conteúdos sobre gestão de oficinas mecânicas direto no seu e-mail.
          </p>
          <form className="flex flex-col sm:flex-row gap-3 max-w-lg mx-auto">
            <input 
              type="email" 
              placeholder="Seu melhor e-mail" 
              className="flex-1 px-4 py-3 rounded-xl border border-slate-300 focus:outline-none focus:ring-2 focus:ring-blue-600 font-medium"
              required
            />
            <button type="submit" className="bg-blue-600 hover:bg-blue-700 text-white font-bold px-8 py-3 rounded-xl transition-colors">
              Inscrever
            </button>
          </form>
        </div>
      </section>
    </div>
  );
};
